var utils = require('../../utils')
import AppHeader from '../AppHeader'
import DayJs from 'dayjs'

export default {
  name: 'evaluate-question-result-list',
  created () {
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
    this.$store.dispatch('USERTYPE_ALL_GET', {})
  },
  data () {
    return {
      questions: [],
      searchUserType: '',
      searchTitle: '',
      searchEnd: false,
      nextExist: false,
      currentPage: 0
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    userTypes () {
      return this.$store.getters.usertypesAll
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async search (addSearch) {
      let data = {
        search_title: this.searchTitle,
        search_target_user_type: this.searchUserType,
        for_result: true
      }
      if (addSearch) {
        this.currentPage += 1
        data['current_page'] = this.currentPage
        data['add_search'] = true
      } else {
        this.searchEnd = false
        this.currentPage = 0
      }

      let res = await this.$store.dispatch('GET_EVALUATE_QUESTION_LIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      if (addSearch) {
        this.questions = this.questions.concat(res.questions.data)
      } else {
        this.questions = res.questions.data
        this.searchEnd = true
      }
      this.nextExist = res.next_exist
    },
    isBeforeNotificationStartDate (notificationStartDate) {
      let today = DayJs(new Date()).format('YYYY-MM-DD')
      return !DayJs(notificationStartDate).isAfter(today)
    },
    isReleaseStatus (notificationStartDate, endDate) {
      let today = DayJs(new Date()).format('YYYY-MM-DD')

      if (DayJs(today).isBefore(notificationStartDate)) {
        return '未公開'
      }
      if (DayJs(endDate).isBefore(today)) {
        return '公開完了'
      }
      return '公開中'
    },
    goEvaluateQuestionDetail: function (questionId) {
      this.$router.push({ path: '/evaluate_question/' + questionId })
    },
    getColor: function (notificationStartDate, endDate) {
      let today = DayJs(new Date()).format('YYYY-MM-DD')

      if (DayJs(today).isBefore(notificationStartDate)) {
        return 'color-blue'
      }
      if (DayJs(endDate).isBefore(today)) {
        return 'color-gray'
      }
      return 'color-orange'
    },
    async goDataDownload (id) {
      let data = {
        evaluate_question_id: id
      }
      let res = await this.$store.dispatch('CSV_EVALUATE_QUESTION_ANSWER', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.onDownloadCsv(res.res_csv_data, res.normal_question_size, res.personnel_question_size, res.business_question_size)
    },
    onDownloadCsv: function (data, normalQuestionSize, personnelQuestionSize, businessQuestionSize) {
      const csvFileName = 'evaluate_answer.csv'
      let bom = new Uint8Array([0xef, 0xbb, 0xbf])
      let mimeType = 'text/csv'
      let csv = '人事評価対象者社員ID,人事評価対象者名,人事評価対象者役職,評価者社員ID,評価者名,評価者役職,回答状態,'
      for (let i = 1; i <= normalQuestionSize; i++) {
        csv += '常態評価項目' + i + ','
        csv += '常態評価回答' + i
        csv += (i === normalQuestionSize && !personnelQuestionSize && !businessQuestionSize) ? '\n' : ','
      }
      for (let i = 1; i <= personnelQuestionSize; i++) {
        csv += '個人スキル評価項目' + i + ','
        csv += '個人スキル評価回答' + i
        csv += (i === personnelQuestionSize && !businessQuestionSize) ? '\n' : ','
      }
      for (let i = 1; i <= businessQuestionSize; i++) {
        csv += '業務スキル評価項目' + i + ','
        csv += '業務スキル評価回答' + i
        csv += i === businessQuestionSize ? '\n' : ','
      }
      data.forEach(obj => {
        if (obj.target_user_id) {
          csv += this.enquoteForCSV(obj.target_user_id) + ','
        } else {
          csv += ','
        }
        if (obj.target_user_name) {
          csv += this.enquoteForCSV(obj.target_user_name) + ','
        } else {
          csv += ','
        }
        if (obj.target_user_type) {
          csv += this.enquoteForCSV(obj.target_user_type) + ','
        } else {
          csv += ','
        }
        if (obj.answer_user_id) {
          csv += this.enquoteForCSV(obj.answer_user_id) + ','
        } else {
          csv += ','
        }
        if (obj.answer_user_name) {
          csv += this.enquoteForCSV(obj.answer_user_name) + ','
        } else {
          csv += ','
        }
        if (obj.answer_user_type) {
          csv += this.enquoteForCSV(obj.answer_user_type) + ','
        } else {
          csv += ','
        }
        if (obj.is_all_answered) {
          csv += '1,'
        } else {
          csv += '0,'
        }
        for (let i = 1; i <= normalQuestionSize; i++) {
          csv += this.enquoteForCSV(obj[`normal_question_content${i}`]) + ','
          csv += this.enquoteForCSV(obj[`normal_answer_content${i}`])
          csv += (i === normalQuestionSize && !personnelQuestionSize && !businessQuestionSize) ? '\n' : ','
        }
        for (let i = 1; i <= personnelQuestionSize; i++) {
          csv += this.enquoteForCSV(obj[`personal_question_content${i}`]) + ','
          csv += this.enquoteForCSV(obj[`personal_answer_content${i}`])
          csv += (i === personnelQuestionSize && !businessQuestionSize) ? '\n' : ','
        }
        for (let i = 1; i <= businessQuestionSize; i++) {
          csv += this.enquoteForCSV(obj[`business_question_content${i}`]) + ','
          csv += this.enquoteForCSV(obj[`business_answer_content${i}`])
          csv += i === businessQuestionSize ? '\n' : ','
        }
      })
      const blob = new Blob([bom, csv], { type: mimeType })
      let hiddenElement = document.createElement('a')
      hiddenElement.download = csvFileName
      hiddenElement.target = '_blank'
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, csvFileName)
      } else if (window.URL && window.URL.createObjectURL){
        hiddenElement.href = window.URL.createObjectURL(blob)
        document.body.appendChild(hiddenElement)
        hiddenElement.click()
        document.body.removeChild(hiddenElement)
      } else if (window.webkitURL && window.webkitURL.createObject) {
        hiddenElement.href = (window.URL || window.webkitURL).createObjectURL(blob)
        hiddenElement.click()
      }
    },
    enquoteForCSV: function (val) {
      if (!val) return ''
      if (/[",\r\n]/.test(val)) { // ",\r\nが含まれる場合はenquoteする
        val = '"' + val.replace(/"/g, '""') + '"'
      }
      return val
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/evaluate-question-result-list.js